

// Get total cart price
async function getCartPrice() {
  try {
    const cart = await (await fetch('/cart.js')).json();
    return cart.total_price / 100;
  } catch (err) {
    //console.error('Error loading cart:', err);
    return 0;
  }
}

// Get shipping cost for given zip/country
let shippingData = { price: 0, currency: '' };
async function getShippingCost() {
  try {
    // Get country and zip dynamically
    const { country, zip } = await getCountryAndZip();

    if (!zip) return { price: 0, currency: '' };

    const response = await fetch(`/cart/shipping_rates.json?shipping_address[zip]=${zip}&shipping_address[country]=${country}`);
    const data = await response.json();

    const rate = data.shipping_rates?.[0];
    shippingData = rate
      ? { price: Number(rate.price) || 0, currency: rate.currency || '' }
      : { price: 0, currency: '' };

    return shippingData;
  } catch (err) {
    //console.error('Error fetching shipping cost:', err);
    return { price: 0, currency: '' };
  }
}

let isUpdating = false;

// --- Update cart display on frontend ---
async function updateCartDisplay() {
  if (isUpdating) return;
  isUpdating = true;

  try {
    const cartTotal = await getCartPrice();

    // Get country and zip using the helper
    const { country, zip } = await getCountryAndZip();

    const shipping = zip ? await getShippingCost(zip, country) : { price: 0, currency: '' };

    // Update shipping label
    const shippingLabel = document.getElementById('shipping-cost-label');
    const shippingText = window.translations?.shipping_cost || 'Shipping costs';
    shippingLabel.textContent = country
    ? `${shippingText} (${country}):`
    : `${shippingText}:`;

    // Update shipping display (implement this function separately)
    displayShippingCost(shipping);

    // Calculate total
    const totalAmount = cartTotal + Number(shipping.price || 0);

    // Update all elements with total price
    document.querySelectorAll('[data-cart-total-price]').forEach(el => {
      if (shipping.currency === 'CHF') {
        el.textContent = `CHF ${totalAmount.toFixed(2)}`;
      } else {
        const currency = shipping.currency || '';
        el.textContent = `${totalAmount.toFixed(2)}${currency ? ' ' + currency : ''}`;
      }
    });

  } catch (err) {
    //console.error('Error updating cart display:', err);
  } finally {
    isUpdating = false;
  }
}

// --- Helper Function ---
function displayShippingCost(shippingData) {
  const shippingSpan = document.getElementById('shipping-cost');

  if (shippingSpan) {
    if (shippingData.price === 0) {
      shippingSpan.textContent = 'Kostenlos';
    } else if (shippingData.currency === 'CHF') {
      shippingSpan.textContent = `CHF ${shippingData.price.toFixed(2)}`;
    } else {
      shippingSpan.textContent = `${shippingData.price.toFixed(2)} EUR`;
    }
  }
}

// --- Helper: get country and default ZIP ---
async function getCountryAndZip() {
  // Default fallback
  let country = 'CH';

  // Try to get country from orbito
  try {
    const remoteCountry = await orbito.getRemoteCountryCode();
    if (remoteCountry) country = remoteCountry.toUpperCase();
  } catch (err) {
    //console.warn('Could not get country from orbito, using NL as fallback.');
  }

  // Default ZIP codes per country
  const defaultZips = {
    DE: '10115',   // Germany (Berlin)
    CH: '8001',    // Switzerland (Zürich)
    BE: '1000',    // Belgium (Brussels)
    NL: '1011AB',  // Netherlands (Amsterdam)
    LU: '1219',    // Luxembourg
    LI: '9490',    // Liechtenstein (Vaduz)
    IT: '00100',   // Italy (Rome)
  };

  const zip = defaultZips[country] || ''; // fallback to empty string if missing
  return { country, zip };
}

// --- Debug Display ---
async function DebugDisplay() {
  const cartPrice = await getCartPrice();
  const { country, zip } = await getCountryAndZip();
  // Get shipping using the correct zip and country
  const shipping = zip ? await getShippingCost(zip, country) : { price: 0, currency: '' };
  console.log('🌍 Country:', country);
  console.log('🏷 ZIP:', zip);
  console.log('🛒 Cart Price:', cartPrice);
  console.log('🚚 Shipping Cost:', shipping.price, shipping.currency);
}

// Listen for Shopify AJAX cart updates
document.addEventListener('DOMContentLoaded', function() {

  // Helper function to fetch the latest cart
  async function fetchCart() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      return cart;
    } catch (err) {
      //console.error('Error fetching cart:', err);
      return null;
    }
  }

  // Store previous cart state
  let previousCart = null;

  // Polling function to detect changes
  async function checkCartChanges() {
    const cart = await fetchCart();
    if (!cart) return;

    // Compare total price or item count as a simple check
    if (!previousCart || cart.item_count !== previousCart.item_count || cart.total_price !== previousCart.total_price) {
      // Cart changed – trigger your custom event
      const event = new CustomEvent('cart:changed', { detail: cart });
      document.dispatchEvent(event);

      // Update previousCart
      previousCart = cart;
    }
  }

  // Initial fetch
  checkCartChanges();

  // Option 1: Poll every 2 seconds
  setInterval(checkCartChanges, 2000);

  // Option 2: If you are using Shopify AJAX API elsewhere, call checkCartChanges() after cart updates
});

// Example of listening to the custom event
document.addEventListener('cart:changed', function(e) {
  //DebugDisplay();
  updateCartDisplay();
});
